import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import appConfig from '../config';

export type APIVersion = 'v1' | 'v2' | 'v3' | 'v4' | 'v5';

class APIUtil {
  private root: string;

  constructor(root = appConfig.config().baseUrl) {
    this.root = root;
  }

  get(
    path: string,
    config: AxiosRequestConfig = {},
    version: APIVersion = 'v1'
  ): Promise<AxiosResponse> {
    return axios.get(`${this.root}/${version}/${path}`, config);
  }

  post(
    path: string,
    data: any,
    config: AxiosRequestConfig = {},
    version: APIVersion = 'v1'
  ): Promise<AxiosResponse> {
    return axios.post(`${this.root}/${version}/${path}`, data, config);
  }

  put(
    path: string,
    data: any,
    config: AxiosRequestConfig = {},
    version: APIVersion = 'v1'
  ): Promise<AxiosResponse> {
    return axios.put(`${this.root}/${version}/${path}`, data, config);
  }

  patch(
    path: string,
    data: any,
    config: AxiosRequestConfig = {},
    version: APIVersion = 'v1'
  ): Promise<AxiosResponse> {
    return axios.patch(`${this.root}/${version}/${path}`, data, config);
  }

  delete(
    path: string,
    data?: any,
    config: AxiosRequestConfig = {},
    version: APIVersion = 'v1'
  ): Promise<AxiosResponse> {
    return axios.delete(`${this.root}/${version}/${path}`, config);
  }
}

export default APIUtil;

export const api_v2 = new APIUtil(appConfig.config().baseUrl_v2);
